import * as React from "react";
const SvgHeartFillR500 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="#F53F29"
      fillRule="evenodd"
      stroke="#F53F29"
      strokeLinejoin="round"
      d="M9.125 5.597c-.273-1.52-1.6-2.662-3.175-2.594-1.924.082-3.242 1.99-2.894 3.936.539 3.013 4.184 4.924 6.12 8.061 1.937-3.137 5.582-5.048 6.121-8.06.348-1.946-.97-3.855-2.894-3.937-1.574-.068-2.902 1.074-3.176 2.594z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHeartFillR500;
